import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, map, exhaustMap, tap, finalize } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchBulkImportHistory,
    fetchBulkImportHistoryFail,
    fetchBulkImportHistorySuccess,
    importRecord,
    importRecordFailure,
    importRecordSuccess,
} from './bulk-import.action';


import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { DatatableService } from 'src/app/core/services/datatable.service';
import { BulkImportHistoryTableService } from './bulk-import-history-table.service';

@Injectable()
export class BulkImportRecordEffects {

    importRecord$ = createEffect(() =>
        this.actions$.pipe(
            ofType(importRecord),
            exhaustMap((data: any) => {
                const url = 'bulk-import';
                return this.crudServerService.addData(url, data.newData).pipe(
                    map( (response) => {
                        const data = response.data;
                        if(data.failedRows){
                            this.alertService.triggerAlert("ALERTS.rows-not-imported | "+data.failedRows, "warning");
                        }

                        this.alertService.triggerAlert(response.message, "success");
                        this.routeService.triggerRoute(response, "/bulk-import");
                        return importRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => importRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })

                )
            })
        )
    );

    fetchBulkHistory$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchBulkImportHistory),
            exhaustMap(() => {
                const url = 'bulk-import-history';
                return this.crudServerService.fetchTableData(url, this.moduleHistoryTableService).pipe(
                    map( (response) => {

                        const responseData = response.data;

                        this.moduleHistoryTableService.page = responseData.pagination.current_page;
                        this.moduleHistoryTableService.lastPage = responseData.pagination.last_page;
                        this.moduleHistoryTableService.pagination = this.tableService.getPaginationArray(responseData.pagination.current_page, responseData.pagination.last_page);

                        this.alertService.triggerAlert(response.message, "success");
                        const data = response.data;
                        return fetchBulkImportHistorySuccess({bulkItems: data.records, total: data.pagination.total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchBulkImportHistoryFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        public helperService: HelperService,
        private moduleHistoryTableService: BulkImportHistoryTableService,
        private tableService: DatatableService,
    ) { }

}